import { Link } from 'react-router-dom';
import ctaBg from '../../../assets/cta-bg.jpg';

export default function CTASection() {
  return (
    <section className="bg-[#070B14] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src={ctaBg}
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0C1220]/97 via-[#0C1220]/90 to-[#0C1220]/80"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10 p-10 lg:p-16">
            <div className="max-w-xl text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start gap-2 mb-5">
                <span className="w-6 h-px bg-[#3B82F6]"></span>
                <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                  Let&apos;s Work Together
                </span>
              </div>
              <h2 className="font-display text-3xl lg:text-4xl font-bold text-white leading-tight mb-4 text-balance">
                Ready to Build Something Great?
              </h2>
              <p className="text-slate-400 leading-relaxed">
                Tell us about your project and let&apos;s discuss how we can help you achieve
                your goals. No commitment required – just a conversation.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-semibold px-8 py-3.5 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Start a Project
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <a
                href="mailto:info@devstander.com"
                className="inline-flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                Send an Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
